export const minPastAccomplishments = '3';
export const minFutureAccomplishments = '2';
